import { axiosInstance } from '@/utils/axios';
import { decryptJson } from '@/utils/encryption';

import { ApiErrorCode, withApiErrorHandler } from './errors';

const ENCRYPTION_KEY = import.meta.env.VITE_RESPONSE_ENCRYPTION_KEY;

export const getEnabledFeatureFlags = async (): Promise<string[]> => {
  const endpoint = '/api/feature-flags/enabled';
  const response = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.get<{ data: { featureFlags: string } }>(endpoint)
  );
  if (!response.featureFlags || !ENCRYPTION_KEY) return [];
  return decryptJson<string[]>(response.featureFlags, ENCRYPTION_KEY);
};
